module.exports = __webpack_public_path__ + "img/taawun.869967a2.png";